import {
  createApiFactory,
  createComponentExtension,
  createPlugin,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';
import {
  I18nDictionaryManagerApiClient,
  i18nDictionaryManagerApiRef,
} from './api/I18nDictionaryManagerApi';
import { rootRouteRef } from './routes';

export const i18nDictionaryManagerPlugin = createPlugin({
  id: 'i18n-dictionary-manager',
  routes: {
    root: rootRouteRef,
  },
  apis: [
    createApiFactory({
      api: i18nDictionaryManagerApiRef,
      deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
      factory({ discoveryApi, fetchApi }) {
        return new I18nDictionaryManagerApiClient({ discoveryApi, fetchApi });
      },
    }),
  ],
});

export const EntityTranslationsContent = i18nDictionaryManagerPlugin.provide(
  createComponentExtension({
    name: 'EntityTranslationsContent',
    component: {
      lazy: () =>
        import('./components/EntityTranslationsContent').then(
          m => m.EntityTranslationsContent,
        ),
    },
  }),
);
